import {PureComponent} from "react";
import * as React from "react";
import {NavLink} from "react-router-dom";
import {SchoolAccessLevel} from "../models/SchoolAccessRecord";
import { License } from "../models/School";


export interface CDBNavLinkDefinition
{
    path: string;
    text: string;
    onClick?: () => void;
}

export interface CDBSchoolNavLinkDefinition extends CDBNavLinkDefinition
{
    level: SchoolAccessLevel;
    licenseAtLeast: License;
}

interface CDBNavLinkProps
{
    definition: CDBNavLinkDefinition;
    onVisible?: (isVisible: boolean,definition: CDBNavLinkDefinition) => void;
    onClick?: () => void;
}

interface CDBNavLinkState
{
    ref: any;
}

export default class CDBNavLink extends PureComponent<CDBNavLinkProps,CDBNavLinkState>
{
    constructor(props: Readonly<CDBNavLinkProps>) {
        super(props);

        this.state = {
            ref: React.createRef()
        };
    }
    
    private observer?: IntersectionObserver;
    
    public componentDidMount() {
        
        if(!this.props.onVisible)
        {
            return;
        }
        
        const callback = (entries: any , observer: any) => {
            entries.forEach((entry: any) => {
                this.props.onVisible!(entry.isIntersecting,this.props.definition);
            });
        };

        let options = {
            root: document.querySelector('body'),
            rootMargin: '10%',
            threshold: 1.0
        }
        
        this.observer = new IntersectionObserver(callback, options);
        this.observer.observe(this.state.ref.current);
    }
    
    componentWillUnmount() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }
    
    public render() {
        
        
        if(this.props.definition.onClick)
        {
            return (
                <a ref={this.state.ref}  className="cdb-admin-nav-link" key={this.props.definition.path} onClick={() => {
                    this.props.definition.onClick!();
                    if(this.props.onClick)
                    {
                        this.props.onClick();
                    }
                }}>{this.props.definition.text}</a>
            );
        }
        
        return (
            <NavLink ref={this.state.ref} className="cdb-admin-nav-link" key={this.props.definition.path} to={this.props.definition.path} activeClassName="cdb-admin-nav-link--active" onClick={this.props.onClick}>{this.props.definition.text}</NavLink>
        );
    }
}
